<form [formGroup]="formGroup"
      (ngSubmit)="onSubmit()"
      class="label-prompt-molecule-root">
  <app-label isBig>{{title}}</app-label>
  <app-input [label]="inputLabel"
             [control]="formControl"
             [formGroup]="formGroup"
             [disabled]="inputDisabled"
             id="invite-repr-email-input"
  ></app-input>
  <app-label *ngIf="errorMsg" isError>{{errorMsg}}</app-label>
  <app-primary-button id="invite-repr-button"
                      type="submit"
                      [abstractControl]="formGroup"
                      [disabled]="buttonDisabled || inputDisabled">
    {{buttonLabel}}
  </app-primary-button>
</form>
